import Route from '@ember/routing/route';
import { service } from '@ember/service';
import protectedRoute from 'lumen/utils/decorators/protected-route';
import { PORTFOLIO_SETTINGS_PATHS } from 'lumen/utils/spider';

@protectedRoute({ features: ['spider.settings.portfolio.edit'] })
export default class MarketSettingsSpiderIndexRoute extends Route {
  @service router;

  redirect() {
    this.router.replaceWith(
      'market.settings.spider.spider-dashboard',
      PORTFOLIO_SETTINGS_PATHS[0],
    );
  }
}
